module.exports = __webpack_public_path__ + "static/media/Annunciator.bcfc5e35.jpg";